"use client";

import { useEffect } from "react";

type UaData = {
  getHighEntropyValues?: (hints: string[]) => Promise<{ platformVersion?: string }>;
};

export default function OsVersionClass() {
  useEffect(() => {
    const root = document.documentElement;
    if (!root.classList.contains("os-mac")) return;

    const uaData = (navigator as Navigator & { userAgentData?: UaData }).userAgentData;
    if (!uaData?.getHighEntropyValues) return;

    uaData
      .getHighEntropyValues(["platformVersion"])
      .then((data) => {
        const parts = String(data.platformVersion || "")
          .split(".")
          .map((n) => Number(n) || 0);
        const major = parts[0] || 0;
        const minor = parts[1] || 0;
        const patch = parts[2] || 0;

        const add = (cls: string) => {
          root.classList.add(cls);
          document.body?.classList.add(cls);
        };

        if (major >= 26) add("os-mac-tahoe");
        if (major > 0) {
          add(`os-mac-${major}`);
          add(`os-mac-${major}-${minor}`);
          add(`os-mac-${major}-${minor}-${patch}`);
        }
      })
      .catch(() => {});
  }, []);

  return null;
}
